// extracted by mini-css-extract-plugin
export default {"step":"StepElement_step__34htn","stepText":"StepElement_stepText__blbwx","resetP":"StepElement_resetP__jvmBU"};